import { render } from "./PreviewCode.vue?vue&type=template&id=c4fe783e&scoped=true"
import script from "./PreviewCode.vue?vue&type=script&lang=js"
export * from "./PreviewCode.vue?vue&type=script&lang=js"

import "./PreviewCode.vue?vue&type=style&index=0&id=c4fe783e&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4fe783e"]])

export default __exports__